module.exports = __webpack_public_path__ + "static/media/port.ce110838.png";